namespace AgerLMS {
    export interface ScriptSiteSetting {
        ReceptionModuleIsActive?: boolean;
        CaseManagerModuleIsActive?: boolean;
    }
}
